import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CircleSpinner',
  props: {
    animationDuration: { default: 1000 },
    size: { default: 50 },
    color: { default: '#fff' },
    display: { default: 'inline-block' }
  },
  setup(__props: any) {

const props = __props as { animationDuration: number, size: number, color: string, display: string };



const circleStyle = computed(() => {
  return {
    display: props.display,
    borderColor: props.color,
    animationDuration: `${props.animationDuration}ms`,
    height: `${props.size}px`,
    width: `${props.size}px`,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "circle",
    style: _normalizeStyle(_unref(circleStyle))
  }, null, 4))
}
}

})